import { usePrivacyMask } from "@nimit9/signet-ui/components/privacy-mask"
import { useMemo } from "react"
import { createCurrencyFormatter, maskedAmountText } from "@/lib/format"
import { useHousehold } from "./use-household"

/**
 * The household's currency formatter. While the header's "Hide amounts" mask
 * is on it returns the fixed placeholder instead (PAISA-PRIV-01), so every
 * screen that formats money through this hook — sentences, KPI tiles, chart
 * axes — is masked without per-screen code.
 */
export function useCurrencyFormat() {
  const { data } = useHousehold()
  const { masked } = usePrivacyMask()
  const currency = data?.household?.currency ?? "INR"
  const locale = data?.household?.locale ?? "en-IN"
  return useMemo(() => {
    if (masked) {
      const text = maskedAmountText(currency, locale)
      return (_amount: number | string, _precise = false): string => text
    }
    return createCurrencyFormatter(currency, locale)
  }, [currency, locale, masked])
}
